export default __webpack_public_path__ + "static/media/burger-logger-img.153af8eb.png";